const arrayToObject = (arr, keyField, valueField) =>
  Object.assign({}, ...arr.map(item => ({ [item[keyField]]: item[valueField] })));

export const preFillExtra = quotation => {
  if (typeof quotation !== 'undefined') {
    const { calc, extra } = quotation;
    if (extra) return quotation;
    if (calc && calc.contract && Array.isArray(calc.contract.extra)) {
      return { ...quotation, extra: arrayToObject(calc.contract.extra, 'code', 'default') };
    }
  }
  return quotation;
};

export const preFillLoan = quotation => {
  if (typeof quotation !== 'undefined') {
    const { loan } = quotation;
    if (loan) return quotation;
    return {
      ...quotation,
      loan: [
        {
          kind: 'fixed_rate',
          amount: '',
          duration: '',
          duration_unit: 'month',
          payment_frequency: 'month'
        }
      ]
    };
  }
  return quotation;
};
